export default __webpack_public_path__ + "static/media/2012-AMcover.59905541.png";